import HealthHeartLine from './health-heart-line.component.js'

export * from './health-heart-line.component.js'
export default HealthHeartLine

HealthHeartLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-heart-line': HealthHeartLine
  }
}
